import { ActionSheetItem, ActionSheetWrapper, Button, ContentGroup, Icon, Pagination } from '@ketch-com/deck'
import { Box } from '@mui/material'
import { PurposeListItem } from 'pages/insights/auditLog/components/consentsTab/components/PurposeListItem/PurposeListItem'
import { useAuditLogContext } from 'pages/insights/auditLog/context/AuditLogContext'
import { useState } from 'react'

const rowsPerPageOptions = [5, 10, 20]

export const ConsentTabPurposes = () => {
  const { consentData } = useAuditLogContext()
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  // Action sheet state
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  // Calculate pagination vars
  const rowCount = consentData?.length || 0
  const pageCount = Math.ceil(rowCount / rowsPerPage)
  const rows = consentData?.slice((page - 1) * rowsPerPage, page * rowsPerPage) || []

  // Action sheet handlers
  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuItemClick = (_: React.MouseEvent<HTMLElement>, index: number) => {
    setRowsPerPage(index)
    setAnchorEl(null)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <ContentGroup
      title="Purposes"
      titleVariant="h3"
      subTitle="The status of each purpose associated with this consent record."
    >
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" flexDirection="column" maxWidth="1216px">
          {rows.map(purpose => (
            <PurposeListItem key={purpose.code} purpose={purpose} />
          ))}
        </Box>
        {pageCount > 1 && (
          <Box display="flex" justifyContent="space-between">
            <Button color="tertiary" onClick={handleButtonClick} endIcon={<Icon name="OArrowCDown" />}>
              {rowsPerPage} Items per page
            </Button>
            <ActionSheetWrapper anchorEl={anchorEl} open={open} onClose={handleClose}>
              {rowsPerPageOptions.map(val => {
                const selected = val === rowsPerPage
                return (
                  <ActionSheetItem
                    key={val}
                    onClick={e => handleMenuItemClick(e, val)}
                    selected={selected}
                    showSelectedIcon={false}
                  >
                    {val}
                  </ActionSheetItem>
                )
              })}
            </ActionSheetWrapper>

            <Pagination size="medium" count={pageCount} page={page} onChange={(_, newPage) => setPage(newPage)} />
          </Box>
        )}
      </Box>
    </ContentGroup>
  )
}
